import { LocalService } from './../../../../core/services/storage/local.service';
import { EmitService } from './../../../../core/services/utils/emit.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { EstadosService } from './../../../../core/services/http/estados.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { SweetAlertService } from 'src/app/core/services/utils/sweet-alert.service';

@Component({
  selector: 'app-modal-excepcion-fila',
  templateUrl: './modal-excepcion-fila.component.html',
  styleUrls: ['./modal-excepcion-fila.component.css']
})
export class ModalExcepcionFilaComponent implements OnInit {
  detalle: any;
  reanudar!: boolean;
  escritorio: any;
  urgenteForm!: FormGroup;
  emiStatus: any;
  urgenteIsSubmitted = false;
  numTurno: any;


  constructor(
    private estados: EstadosService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private emit: EmitService,
    private localSecureService: LocalService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
    this.escritorio = this.localSecureService.getValue('escritorio');
    this.getSeries();
    this.setFormExcepcionFila();
  }

   /* Obtiene las series correspondiente a esa oficina */
   async getSeries() {
    const idOficina = this.escritorio.idOficina;
    await this.estados.getSeries(idOficina).then((data) => {
      const emiStatus:any = data;
      this.emiStatus = emiStatus.getSeriesaDerivar;
    });
  }

  setFormExcepcionFila() {
    this.urgenteForm = this.formBuilder.group({
      serie: [null, [Validators.required]],
      turno: [0, [
        Validators.required,
        Validators.pattern(/^[0-9]\d*$/)
      ]],
    });
  }

  onSubmitExcepcion(){
    if(!this.localSecureService.getValue('consultora')) {
      this.sweetAlertService.swalInternet();
      return;
    }

    this.urgenteIsSubmitted = true;

    if (this.urgenteForm.invalid) {
      return;
    }
    //this.spinner.show();
    const idSerie = this.urgenteForm.value.serie.idSerie;
    const numTurno = this.urgenteForm.value.turno;
    this.modalService.closeModal();
    if(this.reanudar){
      this.emit.enviarData({idSerie,numTurno,reanudar:true});
    } else {
      this.emit.enviarData({idSerie,numTurno});
    }
    

    //this.spinner.hide();
  }

  cerrar(){
    this.closeModal();
    switch (this.detalle) {
      case "En espera":
        this.emit.enviarData('sesion');
        break;
      case "Llamando":
          this.emit.enviarData('cierraPausa');
          break;
      case "Pausa":
          this.emit.enviarData('sesion');
          break;
    }
  }

  closeModal(): void {
    this.modalService.closeModal();
  }

}
